// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type ApiError, type PromptListe } from "../../api";
import { useGetIcpFallbackPromptsByPhoneNumberId as useGetter } from "../hooks";
import { type QueryKey, useQuery, type UseQueryOptions } from "react-query";

export function useIcpFallbackPromptsByPhoneNumberIdQueryKey(
  phoneNumberId: string
): QueryKey {
  return ["api", "v1", "phonenumbers", phoneNumberId, "icp-fallback-prompts"];
}

export function useIcpFallbackPromptsByPhoneNumberId(
  phoneNumberId: string,
  options: Omit<
    UseQueryOptions<PromptListe, ApiError>,
    "queryKey" | "queryFn"
  > = {}
): PromptListe {
  const getter = useGetter();
  return useQuery(
    useIcpFallbackPromptsByPhoneNumberIdQueryKey(phoneNumberId),
    () => getter(phoneNumberId),
    options
  ).data!;
}
